{
  "blocks": [
    {
      "id": "med-intralipid",
      "kind": "medication",
      "tags": [
        "medications",
        "her",
        "during-cycle",
        "ivf",
        "fet",
        "autoimmune",
        "evidence-based"
      ],
      "title": "Intralipid Infusion",
      "subtitle": "IV fat emulsion used for immune modulation around embryo transfer",
      "body": {
        "genericName": "Intralipid (20% IV fat emulsion)",
        "drugClass": "Immune modulator (lipid emulsion)",
        "purpose": "An intravenous fat emulsion that some clinics discuss off-label as an immune-related add-on around embryo transfer. Evidence for fertility outcomes is limited and debated, and it is not a routine treatment. Whether it is appropriate depends on your clinician's review, your history, and the product's safety information.",
        "commonRoutes": ["intravenous"],
        "commonForms": ["vial"],
        "dosageRanges": "There is no universal FET dose or infusion schedule. Your clinic must confirm the exact product, preparation, amount, route, timing, and monitoring plan.",
        "howToTake": "Intralipid is administered by trained staff at a clinic or infusion centre; do not prepare or inject it yourself. Follow your clinic's order for the product, preparation, timing, infusion rate, observation, and follow-up. Tell the care team about allergies, prior infusion reactions, and relevant medical conditions before treatment. Ask the clinic what to do about a late or missed appointment and seek urgent help for trouble breathing, chest tightness, severe vomiting, or other signs of a serious reaction.",
        "sideEffects": [
          "Mild headache during or after infusion",
          "Nausea",
          "Flushing or warmth sensation",
          "Fatigue",
          "Allergic reaction (rare - inform your clinic of soy or egg allergy)",
          "Injection site discomfort"
        ],
        "storage": "Stored at the clinic. Must be refrigerated (2-8°C / 36-46°F) until use. Single-use - discard any unused portion.",
        "brandsByCountry": [
          {
            "country": "US",
            "brands": ["Intralipid", "Smoflipid"]
          },
          {
            "country": "UK",
            "brands": ["Intralipid", "ClinOleic"]
          },
          {
            "country": "EU",
            "brands": ["Intralipid", "Smoflipid", "ClinOleic"]
          },
          {
            "country": "AU",
            "brands": ["Intralipid", "Smoflipid"]
          },
          {
            "country": "FR",
            "brands": ["Intralipide"],
            "cisByBrand": {
              "Intralipide": "62551291"
            }
          }
        ],
        "availability": [
          {
            "name": "Intralipid",
            "manufacturer": "Fresenius Kabi",
            "countries": ["US", "EU", "GB", "AU", "CA", "HK", "SG"]
          },
          {
            "name": "SMOFlipid",
            "manufacturer": "Fresenius Kabi",
            "countries": ["US", "EU", "GB", "AU", "CA", "SG", "HK"]
          },
          {
            "name": "ClinOleic",
            "manufacturer": "Baxter",
            "countries": ["GB", "EU"]
          },
          {
            "name": "Liposyn",
            "manufacturer": "Hospira",
            "countries": ["US"]
          }
        ],
        "aliases": [
          "Intralipide",
          "Intralipid infusion",
          "Perfusion d'Intralipide"
        ],
        "forWhom": "her",
        "frBody": {
          "genericName": "Intralipide (émulsion lipidique IV à 20 %)",
          "drugClass": "Immunomodulateur (émulsion lipidique)",
          "purpose": "Émulsion lipidique intraveineuse dont certains centres discutent l'utilisation hors AMM comme complément lié à l'immunité autour du transfert d'embryon. Les données sur les résultats en fertilité sont limitées et débattues ; ce n'est pas un traitement de routine. Son intérêt dépend de l'évaluation de votre clinicien, de vos antécédents et des informations de sécurité du produit.",
          "dosageRanges": "Il n'existe pas de dose ni de calendrier de perfusion universels pour un TEC. Votre centre doit confirmer le produit, la préparation, la quantité, la voie, le calendrier et la surveillance nécessaires.",
          "howToTake": "L'Intralipide est administré par du personnel formé dans un centre ou un lieu de perfusion ; ne le préparez pas et ne vous l'injectez pas vous-même. Suivez l'ordonnance de votre centre pour le produit, la préparation, le calendrier, le débit, la surveillance et le suivi. Signalez à l'équipe vos allergies, vos réactions antérieures aux perfusions et vos problèmes de santé pertinents. Demandez au centre quoi faire en cas de rendez-vous retardé ou manqué et consultez en urgence en cas de difficultés respiratoires, d'oppression thoracique, de vomissements sévères ou d'autres signes de réaction grave.",
          "sideEffects": [
            "Léger mal de tête pendant ou après la perfusion",
            "Nausées",
            "Bouffée de chaleur ou sensation de chaleur",
            "Fatigue",
            "Réaction allergique (rare - signalez toute allergie au soja ou à l'œuf à votre centre)",
            "Inconfort au point d'injection"
          ],
          "storage": "Conservé en clinique. Doit être conservé au réfrigérateur (2-8 °C) jusqu'à utilisation. À usage unique - jetez toute portion non utilisée."
        }
      }
    }
  ],
  "relationships": [],
  "localeVariants": []
}
